const tpDailyDc = {
  dc: 'DC',
  assessMonth: 'AssessMonth',
  assessMonthStart: 'StartMonth',
  assessMonthEnd: 'EndMonth',
  carrierCode: 'CarrierCode',
  serviceProvider: 'ServiceProvider',
  assessItem: 'AssessItem',
  versionNo: 'VersionNo',
  category: 'Category',
  assessContent: 'AssessContent',
  citationClause: 'CitationClause',
  score: 'Score',
  occurCount: 'OccurCount',
  adjustScore: 'AdjustScore',
  breachExample: 'BreachExample',
  statCategory: 'StatCategory',
  createTime: 'CreateTime',
  msg: {}
};
export default tpDailyDc;



// WEBPACK FOOTER //
// ./src/page/assess/tpDailyDc/lang/tpDailyDc.en.js